import { Col, Row } from "antd";
import useDomain from "src/shared/hooks/useDomain";
import "./questions.less";
const LQuestions = () => {
  const { name } = useDomain();

  return (
    <section id="questions">
      <Row justify="center">
        <Col xs={22} md={20}>
          <div className="index_title_questons">
            <h3>سوالات متداول</h3>
            <p>
              روزانه هزاران کاربر خوشحال با ما کار می کند.ما در حال کمک به مشاغل
              موجود در اینستاگرام هستیم.
            </p>
          </div>
          <Row justify="space-between" align="middle" gutter={[30, 30]}>
            <Col xs={24} sm={8} className="col-index_info">
              <div className="text-index-info">
                <h5>چرا باید فالور و یا لایک بخریم؟</h5>
                <p>
                  افزایش فالور اینستاگرام کارکرد اصلی سیستم های فالوور می باشد
                  .اینکار با ثبت پیج اینستاگرام خود و رقیبان اغاز می شود و تا
                  زمانی که تعداد فالور شما به حد موردنظر نرسد ،
                </p>
              </div>
            </Col>
            <Col xs={24} sm={8} className="col-index_info">
              <div className="text-index-info">
                <h5>{name} چگونه کار می کند؟</h5>
                <p>
                  افزایش فالور اینستاگرام کارکرد اصلی سیستم های فالوور می باشد
                  .اینکار با ثبت پیج اینستاگرام خود و رقیبان اغاز می شود و تا
                  زمانی که تعداد فالور شما به حد موردنظر نرسد ،
                </p>
              </div>
            </Col>
            <Col xs={24} sm={8} className="col-index_info">
              <div className="text-index-info">
                <h5>
                  آیا فالورهایی که اضافه می شوند پست های من را لایک خواهند کرد؟
                </h5>
                <p>
                  افزایش فالور اینستاگرام کارکرد اصلی سیستم های فالوور می باشد
                  .اینکار با ثبت پیج اینستاگرام خود و رقیبان اغاز می شود و تا
                  زمانی که تعداد فالور شما به حد موردنظر نرسد ،
                </p>
              </div>
            </Col>
            <Col xs={24} sm={8} className="col-index_info">
              <div className="text-index-info">
                <h5>
                  برای استفاده از {name} حتما باید در آن ثبت نام کنم و یا از
                  ربات رشد هوشمند استفاده کنم؟
                </h5>
                <p>
                  افزایش فالور اینستاگرام کارکرد اصلی سیستم های فالوور می باشد
                  .اینکار با ثبت پیج اینستاگرام خود و رقیبان اغاز می شود و تا
                  زمانی که تعداد فالور شما به حد موردنظر نرسد ،
                </p>
              </div>
            </Col>
            <Col xs={24} sm={8} className="col-index_info">
              <div className="text-index-info">
                <h5>مجوز ها و اعتبارات {name} چیست؟</h5>
                <p>
                  افزایش فالور اینستاگرام کارکرد اصلی سیستم های فالوور می باشد
                  .اینکار با ثبت پیج اینستاگرام خود و رقیبان اغاز می شود و تا
                  زمانی که تعداد فالور شما به حد موردنظر نرسد ،
                </p>
              </div>
            </Col>
            <Col xs={24} sm={8} className="col-index_info">
              <div className="text-index-info">
                <h5>
                  آیا احتمال بسته شدن اکانت من توسط اینستاگرام بعد از افزایش
                  لایک و فالور وجود دارد؟
                </h5>
                <p>
                  افزایش فالور اینستاگرام کارکرد اصلی سیستم های فالوور می باشد
                  .اینکار با ثبت پیج اینستاگرام خود و رقیبان اغاز می شود و تا
                  زمانی که تعداد فالور شما به حد موردنظر نرسد ،
                </p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default LQuestions;
